export default "__VITE_ASSET__DBc33EtN__"